/// <reference types="vite/client" />

import { QueryClientProvider } from "@tanstack/react-query"
import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from "@tanstack/react-router"
import { DefaultCatchBoundary } from "components/DefaultCatchBoundary"
import { AuthProvider } from "contexts/auth-context/AuthProvider"
import type { RootContext } from "contexts/root-context/RootContext"
import { trpc } from "lib/trpc"
// import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import type * as React from "react"
import { I18nextProvider } from "react-i18next"
import { Toaster } from "sonner"
import { NotFound } from "@/components/not-found"
import appCss from "../styles/app.css?url"

export const Route = createRootRouteWithContext<RootContext>()({
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      {
        title: "Legacy Keeper",
      },
    ],
    links: [
      { rel: "stylesheet", href: appCss },
      { rel: "icon", href: "/images/favicon.png" },
    ],
  }),
  errorComponent: (props) => {
    return <DefaultCatchBoundary {...props} />
  },
  notFoundComponent: () => <NotFound />,
  component: RootComponent,
})

function RootComponent() {
  const { i18n, queryClient, trpcClient } = Route.useRouteContext()
  return (
    <AuthProvider>
      <trpc.Provider client={trpcClient} queryClient={queryClient}>
        <QueryClientProvider client={queryClient}>
          <I18nextProvider i18n={i18n.instance}>
            <RootDocument>
              <Outlet />
            </RootDocument>
          </I18nextProvider>
        </QueryClientProvider>
      </trpc.Provider>
    </AuthProvider>
  )
}

function RootDocument({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
        <link
          href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&family=DM+Serif+Display:ital@0;1&display=swap"
          rel="stylesheet"
        />
        <script
          // biome-ignore lint/security/noDangerouslySetInnerHtml: GTM bootstrap snippet is a trusted, static string — no user input involved
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRTHNWH9');`,
          }}
        />
        <HeadContent />
      </head>
      <body>
        {children}
        <Toaster />
        {/* <TanStackRouterDevtools position="bottom-right" /> */}
        <Scripts />
      </body>
    </html>
  )
}
